import React, { InputHTMLAttributes } from "react";
import { cn } from "../../lib";

export interface ICustomInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  leading?: JSX.Element | string;
  trailing?: JSX.Element | string;
  error?: boolean;
  containerClassName?: string;
  errorMessage?: any;
  label?: string;
}

const ICTextInput: React.FC<ICustomInputProps> = ({
  leading,
  trailing,
  error,
  errorMessage,
  containerClassName,
  label,
  required,
  disabled,
  placeholder,
  ...inputProps
}) => {
  return (
    <div className="floating-input">
      <div
        className={cn("custom-text-input-container", {
          "error-border": errorMessage,
          [`${containerClassName}`]: containerClassName,
        })}
      >
        {leading && <div>{leading}</div>}
        <div className="flex w-full ">
          <input
            className={cn("custom-text-input bg-transparent", {
              "text-disable": disabled,
              "no-placeholder": !placeholder,
              "has-placeholder": !!placeholder,
            })}
            disabled={disabled}
            {...inputProps}
            placeholder={placeholder ?? "p"}
          />
          {label && (
            <label className="px-1">{label + (required ? "*" : "")}</label>
          )}
        </div>
        {trailing && <div>{trailing}</div>}
      </div>
      {errorMessage && (
        <div className="text-sm text-danger">{errorMessage}</div>
      )}
    </div>
  );
};
export default ICTextInput;
